import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning\">\r\n<path d=\"M10.7323 1.93977C10.9783 2.0765 11.1812 2.27937 11.318 2.52542L18.8102 16.0094C18.9378 16.2391 19.0032 16.498 18.9999 16.7607C18.9966 17.0234 18.9248 17.2806 18.7915 17.507C18.6582 17.7334 18.4681 17.921 18.24 18.0513C18.0118 18.1817 17.7536 18.2501 17.4909 18.25H2.50858C2.2459 18.25 1.98776 18.1815 1.75972 18.0512C1.53167 17.9208 1.34163 17.7332 1.2084 17.5068C1.07517 17.2804 1.00337 17.0232 1.00012 16.7606C0.996858 16.498 1.06225 16.239 1.18983 16.0094L8.6815 2.52542C8.87582 2.17588 9.20103 1.91782 9.5856 1.80799C9.97018 1.69816 10.3826 1.74556 10.7323 1.93977ZM10.7539 13.7257H9.2456V15.2338H10.7539V13.7257ZM10.7539 7.21162H9.2456V12.7203H10.7539V7.21162Z\" fill=\"#FF7D3F\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/warning.svg
// module id = TcIt
// module chunks = 36